import queryString from 'query-string';

export default function getQueryParam(paramName: string, requestUrl = '') {
  const qs = queryString.parseUrl(
    typeof window === 'undefined' ? requestUrl : window.location.search
  );
  return qs[paramName];
}
